import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { PrivacyEvents, PrivacyValuesService } from '../../../../common/values/privacy.values.service';
import { PrivacyActionsService } from '../../privacyActions.service';
import { PrivacyService } from '../../../../common/services/process/privacy/privacy.service';
import { MessageService } from '../../../../common/services/core/message.service';
import { ValuesService } from '../../../../common/values/values.service';
import { PrivacyEducationService } from '../../../../common/services/process/privacy/privacy.education.service';
import { ConfigService } from '../../../../common/config/config.service';
import { LanguageService } from '../../../../common/services/core/language.service';

@Component({
    selector: 'privacy-education-aside',
    templateUrl: './privacy-education-aside.component.html'
})

export class PrivacyEducationAsideComponent implements OnInit, OnDestroy {

    @Input() filter: string;                                             //for ngmodel binding, unnecesary right now
    @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() topicsCountLoaded: EventEmitter<any> = new EventEmitter<any>();

    onDestroy$: Subject<void> = new Subject<void>();
    currentLang = '';
    topicsCount;
    activeFilter = this.privacyActionsService.selectedCategoryForEducation;  // marks selected filter
    topics = [];

    constructor(
        private readonly privacyActionsService    : PrivacyActionsService,
        private readonly privacyValuesService     : PrivacyValuesService,
        private readonly privacyService           : PrivacyService,
        private readonly translateService         : TranslateService,
        private readonly messageService           : MessageService,
        private readonly router                   : Router,
        private readonly valuesService            : ValuesService,
        private readonly privacyEducationService  : PrivacyEducationService,
        private readonly configService  : ConfigService,
        private readonly languageService         : LanguageService

    ) {
        this.translateService.onLangChange
        .pipe(takeUntil(this.onDestroy$))
        .subscribe( () => {
            this.topics = [];
            this.start();
        });

        this.messageService.getMessage()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(msg => {
            if (msg.text === PrivacyEvents.UPDATE_TOPIC && msg.options) {
                this.activeFilter = msg.options.activeTopic;
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.filter && changes.filter.currentValue) {
            this.activeFilter = changes.filter.currentValue;
        }
    }

    ngOnInit() {
        this.start();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    filterTopicsByFeatureSet() {
        const hasBreaches = this.configService.getPrivacyBreaches();
        const hasImpersonations = this.configService.getPrivacyImpersonations();
        const hasFootprint = this.configService.getPrivacyFootprint();

        if (!hasBreaches) {
            delete this.privacyValuesService.educationArticles.breaches;
        }

        if (!hasImpersonations) {
            delete this.privacyValuesService.educationArticles.impersonations;
        }

        if (!hasFootprint) {
            delete this.privacyValuesService.educationArticles.digital_footprint;
        }
    }

    start() {
        this.currentLang = this.languageService.getLang();
        this.filterTopicsByFeatureSet();

        for (const key in this.privacyValuesService.educationArticles) {
            this.topics.push(this.privacyValuesService.educationArticles[key].topic);
        }

        this.privacyEducationService.countEducationArticles(this.topics, this.languageService.getLang())
        .pipe(takeUntil(this.onDestroy$))
        .subscribe({
            next: res => {
                this.topicsCount = res;
                this.topicsCountLoaded.emit(this.topicsCount);
            },
            error: err => {
                if (err.redirect500) {
                    this.router.navigate([this.valuesService.centralPaths['500'].path]);
                } else {
                    this.privacyService.checkParkedIdentity(err, false);
                }
            }
        });
    }

    filterByTopic(topic?) {
        event.preventDefault();

        this.activeFilter = topic;
        this.privacyActionsService.selectedCategoryForEducation = topic;
        this.filterChange.emit(topic);
        const educationPage = this.valuesService.centralPaths.privacy.path.concat(this.valuesService.centralPaths.privacy.education.path);

        // navigate to list-page, if filtering is triggered on article-page
        if (this.router.url !== educationPage) {
            this.router.navigate([educationPage]);
        }
    }

    topicArticlesNumber(topic?) {
        if (topic) {
            return this.topicsCount.topics[topic] || 0;
        }
        else {
            return this.topicsCount.total || 0;
        }
    }

}
